/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader';
import queryString from "query-string";
import ExternalProfiles from '../../../components/TaxConsulting/ExternalProfiles';

const TaxConsultingSetting = () => {
  const history = useHistory();

  const [activeTab, setActiveTab] = useState();

  const _setActiveTab = (value) => {
    history.push(`/tax-portal/tax-consulting-setting?tab=${value}`);
  };

  const tabList = [
    {
      label: "프로필 관리",
      action: _setActiveTab,
      value: "external-profile",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  return (
    <>
      <PageHeader
        title={"컨설팅 설정"}
        activeTab={activeTab}
        tabList={tabList}
      />

      {activeTab === "external-profile" && <ExternalProfiles />}
    </>
  );
};

export default TaxConsultingSetting;